import { observer } from 'mobx-react-lite'
import { Button, Icon, Scrollbar, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IProps = {
  handleEdit: () => void
  suggestions: string[]
  handleSkip: () => void
}

export const ValidateSuggestionsModal = observer(
  ({ handleEdit, suggestions, handleSkip }: IProps) => {
    return (
      <div className={styles.wrapModal}>
        <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={'100%'} height={'100%'}>
          <div className={styles.header}>
            <Icon icon='alertTriangleYellow' fontSize={32} className={styles.icon} />
            <Typography variant='heading-lg' ariaLabel='ValidateSuggestionsModal_title'>
              More details needed
            </Typography>
            <Typography
              variant='body-rg-regular'
              ariaLabel='ValidateSuggestionsModal_subtitle'
              color='var(--content-primary-secondary)'
            >
              Update instructions to ensure your agent works properly
            </Typography>
          </div>
          <div className={styles.suggestions}>
            {suggestions.map((text, index) => (
              <div key={index} className={styles.suggestionItem}>
                <span className={styles.number}>{index + 1}</span>
                <Typography variant='body-md-regular' ariaLabel='text'>
                  {text}
                </Typography>
              </div>
            ))}
          </div>
          <div className={styles.editBtn}>
            <Button
              typeBtn='contained'
              fullWidth
              text='Edit instructions'
              contained='primary'
              onClick={handleEdit}
            />
            <Button
              typeBtn='contained'
              fullWidth
              text='Skip for now'
              contained='secondary'
              onClick={handleSkip}
            />
          </div>
        </Scrollbar>
      </div>
    )
  }
)
